module.exports = __webpack_public_path__ + "images/6e6f48bd4212fdf36527f07aeced3475.png";